const DeleteConfirmDialog = ({ isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-6 max-w-md w-full mx-4 relative" dir="rtl">
                <h3 className="text-xl font-heebo font-bold text-[#4a3f30] mb-2">
                    מחיקת הודעה
                </h3>
                <p className="text-[#937c5d] mb-6">
                    האם אתה בטוח שברצונך למחוק את ההודעה? פעולה זו לא ניתנת לביטול.
                </p>
                <div className="flex justify-start gap-3">
                    <button
                        onClick={onConfirm}
                        className="px-4 py-2 bg-red-100 text-red-600 rounded-lg
                        hover:bg-red-200 transition-colors font-heebo"
                    >
                        מחק
                    </button>
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-[#937c5d] hover:text-[#4a3f30]
                        transition-colors font-heebo"
                    >
                        ביטול
                    </button>
                </div>
            </div>
        </div>
    );
};
export default DeleteConfirmDialog;